import {Storage} from '@infra/api';
import {FIRST_LOGIN_KEY} from '@infra/domain/model/Auth/ApiAuthRepository';

const SetHasLoggedIn = () => (): Promise<void> => Promise.resolve(Storage.set(FIRST_LOGIN_KEY, 'false'));

export {SetHasLoggedIn};
